import FormatBoldIcon from '@mui/icons-material/FormatBold';
import FormatItalicIcon from '@mui/icons-material/FormatItalic';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import FormatListNumberedIcon from '@mui/icons-material/FormatListNumbered';
import FormatIndentIncreaseIcon from '@mui/icons-material/FormatIndentIncrease';
import FormatIndentDecreaseIcon from '@mui/icons-material/FormatIndentDecrease';
import UndoIcon from '@mui/icons-material/Undo';
import RedoIcon from '@mui/icons-material/Redo';
import FormatClearIcon from '@mui/icons-material/FormatClear';
import styles from './FormattingToolbar.module.css';

interface FormattingToolbarProps {
	onFormat: (syntax: string) => void;
	onUndo: () => void;
	onRedo: () => void;
	onClearFormat: () => void;
	onIndent: () => void;
	onOutdent: () => void;
	canUndo: boolean;
	canRedo: boolean;
}

export const FormattingToolbar = ({
	onFormat,
	onUndo,
	onRedo,
	onClearFormat,
	onIndent,
	onOutdent,
	canUndo,
	canRedo,
}: FormattingToolbarProps) => {
	return (
		<div className={styles.toolbar}>
			<button
				type="button"
				className={styles.toolbarButton}
				onClick={onUndo}
				disabled={!canUndo}
				title="Desfazer (Ctrl+Z)"
			>
				<UndoIcon />
			</button>
			<button
				type="button"
				className={styles.toolbarButton}
				onClick={onRedo}
				disabled={!canRedo}
				title="Refazer (Ctrl+Y)"
			>
				<RedoIcon />
			</button>
			<div className={styles.toolbarDivider}></div>
			<button
				type="button"
				className={styles.toolbarButton}
				onClick={() => onFormat('bold')}
				title="Negrito (Ctrl+B)"
			>
				<FormatBoldIcon />
			</button>
			<button
				type="button"
				className={styles.toolbarButton}
				onClick={() => onFormat('italic')}
				title="Itálico (Ctrl+I)"
			>
				<FormatItalicIcon />
			</button>
			<div className={styles.toolbarDivider}></div>
			<button
				type="button"
				className={styles.toolbarButton}
				onClick={() => onFormat('h1')}
				title="Título"
			>
				H1
			</button>
			<button
				type="button"
				className={styles.toolbarButton}
				onClick={() => onFormat('h2')}
				title="Subtítulo"
			>
				H2
			</button>
			<div className={styles.toolbarDivider}></div>
			<button
				type="button"
				className={styles.toolbarButton}
				onClick={() => onFormat('ul')}
				title="Lista não ordenada"
			>
				<FormatListBulletedIcon />
			</button>
			<button
				type="button"
				className={styles.toolbarButton}
				onClick={() => onFormat('ol')}
				title="Lista ordenada"
			>
				<FormatListNumberedIcon />
			</button>
			<div className={styles.toolbarDivider}></div>
			<button
				type="button"
				className={styles.toolbarButton}
				onClick={onIndent}
				title="Aumentar recuo (Tab)"
			>
				<FormatIndentIncreaseIcon />
			</button>
			<button
				type="button"
				className={styles.toolbarButton}
				onClick={onOutdent}
				title="Diminuir recuo (Shift+Tab)"
			>
				<FormatIndentDecreaseIcon />
			</button>
			<div className={styles.toolbarDivider}></div>
			<button
				type="button"
				className={styles.toolbarButton}
				onClick={onClearFormat}
				title="Limpar formatação"
			>
				<FormatClearIcon />
			</button>
		</div>
	);
};
